const Measurement = () =>
  import(
    /* webpackChunkName: "base-info-unit-measurement" */ '@/pages/base-info/unit/measurement/index.vue'
  )
const CreateMeasurement = () =>
  import(
    /* webpackChunkName: "base-info-unit-measurement" */ '@/pages/base-info/unit/measurement/create.vue'
  )
const EditMeasurement = () =>
  import(
    /* webpackChunkName: "base-info-unit-measurement" */ '@/pages/base-info/unit/measurement/edit.vue'
  )

export default {
  path: 'measurement',
  meta: {
    label: 'measurement',
    auth: 'measurement'
  },
  component: {
    name: 'Measurement',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaseInfoUnitMeasurement',
      path: '/',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Measurement
    },
    {
      name: 'BaseInfoCreateUnitMeasurement',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateMeasurement
    },
    {
      name: 'BaseInfoEditUnitMeasurement',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditMeasurement,
      props: true
    }
  ]
}
